<template>
  <div class="flex flex-col gap-2">
    <div class="flex items-baseline justify-between gap-4">
      <span :id="`${id}-label`" class="text-base font-medium text-heading">{{ label }}</span>
      <!-- The live context next to the label, like the expected yield for the chosen panel count. -->
      <slot name="hint" />
    </div>
    <div class="flex w-full items-center overflow-hidden rounded-lg border border-line-soft bg-white">
      <button
        type="button"
        :aria-label="decreaseLabel"
        :disabled="modelValue <= min"
        class="h-14 w-[76px] cursor-pointer border-r border-line-soft text-[24px] font-medium text-heading focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-blue-bright disabled:cursor-default disabled:text-muted"
        @click="emit('update:modelValue', modelValue - 1)"
      >
        −
      </button>
      <output
        class="flex h-14 flex-1 items-center justify-center text-lg font-medium text-heading"
        :aria-labelledby="`${id}-label`"
      >
        {{ modelValue }}
      </output>
      <button
        type="button"
        :aria-label="increaseLabel"
        :disabled="modelValue >= max"
        class="h-14 w-[76px] cursor-pointer border-l border-line-soft text-[24px] font-medium text-heading focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-blue-bright disabled:cursor-default disabled:text-muted"
        @click="emit('update:modelValue', modelValue + 1)"
      >
        +
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  id: string
  label: string
  modelValue: number
  min: number
  max: number
  decreaseLabel: string
  increaseLabel: string
}>()

const emit = defineEmits<{ 'update:modelValue': [value: number] }>()
</script>
